import React from "react";
import Header from "../components/Header";
import NavigationSideBar from "../components/NavigationSideBar";
import InnerBody from "../components/InnerBody";
import Table from "../components/Table";
import FlatButton from "../components/FlatButton";
import TitleBar from "../components/TitleBar";
import RaisedButton from "../components/RaisedButton";
import withAuthorization from "../firebase/withAuthorization";

class PageReports extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: false };
  }
  render() {
    return (
      <div>
        <Header
          title="Berichte herunterladen"
          showProjectsDropdown={false}
          showProfile={true}
        />
        <NavigationSideBar page="reports" />
        <InnerBody isLoading={this.state.isLoading}>
          <TitleBar title="Monatsberichte herunterladen">
            <RaisedButton label="Alle herunterladen" onClick={() => {}} />
          </TitleBar>
          <Table
            header={[
              {
                items: ["Name", "Datum", ""]
              }
            ]}
            colSelectables={[2]}
            onItemSelected={index => {}}
            data={[
              {
                items: [
                  "Monatsbericht Juli 2018",
                  "01.07.2018",
                  <p className="Link">
                    <i
                      className="fas fa-download"
                      style={{ textAlign: "center", width: "100%" }}
                    />
                  </p>
                ]
              },
              {
                items: [
                  "Monatsbericht Juni 2018",
                  "01.06.2018",
                  <p className="Link">
                    <i
                      className="fas fa-download"
                      style={{ textAlign: "center", width: "100%" }}
                    />
                  </p>
                ]
              },
              {
                items: [
                  "Monatsbericht Mai 2018",
                  "01.05.2018",
                  <p className="Link">
                    <i
                      className="fas fa-download"
                      style={{ textAlign: "center", width: "100%" }}
                    />
                  </p>
                ]
              }
            ]}
          >
            {null}
          </Table>
        </InnerBody>
      </div>
    );
  }
}

const authCondition = authUser => !!authUser;
export default withAuthorization(authCondition)(PageReports);



// WEBPACK FOOTER //
// ./src/pages/PageReports.js